import React from 'react'
import { Bar } from 'react-chartjs-2'

const Bar1002v2 = ({ name, player1, player2, player3, player4 }) => {
	return (
		<div className="h-20 w-full">
			<div className="flex flex-row w-5/12 justify-between absolute pt-10 -mt-px text-4xl">
				<h1 className="text-white pl-6">
					{parseInt(player1) + parseInt(player2)}
				</h1>
				<h1 className="text-white float-right pr-24">
					{parseInt(player3) + parseInt(player4)}
				</h1>
			</div>

			<h1 className="text-white text-4xl font-bold text-center">
				{name}
			</h1>
			<Bar
				redraw={true}
				data={{
					labels: ['', ''],
					datasets: [
						{
							label: 'good',
							data: [player1],
							backgroundColor: 'rgb(74, 136, 237)',
						},
						{
							label: 'better',
							data: [player2],
							backgroundColor: 'rgb(130, 177, 242)',
						},
						{
							label: 'bad',
							data: [player3],
							backgroundColor: 'rgb(245, 128, 128)',
						},
						{
							label: 'worse',
							data: [player4],
							backgroundColor: 'rgb(240, 67, 67)',
						},
					],
				}}
				options={{
					animation: false,
					maintainAspectRatio: false,
					//@ts-ignore
					indexAxis: 'y',
					barThickness: 32,
					plugins: {
						legend: {
							display: false,
						},
						stacked100: {
							enable: true,
						},
					},
					scales: {
						y: {
							display: false,
							grid: {
								display: false,
							},
						},
						x: {
							grid: {
								display: false,
							},
							display: false,
						},
					},
				}}
			/>
		</div>
	)
}

export { Bar1002v2 }
